import { all, call, fork, put, select, takeEvery } from 'redux-saga/effects';
import requisicaoApi from 'util/ApiEnquete';
import {
  INICIA_ENQUETES,
  LISTA_ENQUETES,
  BUSCA_ENQUETE_EDICAO,
  ABRE_DASHBOARD_ENQUETE,
  REGISTRA_VOTO_ENQUETE,
  SALVA_ENQUETE_LOCAL,
  REMOVE_ENQUETE_LOCAL,
} from 'constants/ActionTypes';
import {
  inicioEnquetesSucesso,
  listaEnquetesSucesso,
  buscaEnqueteEdicaoSucesso,
  abreDashboardEnqueteSucesso,
  registraVotoEnqueteSucesso,
  salvaEnqueteSucesso,
  removeEnqueteSucesso,
  showEnquetesMessage,
  listaEnquetes,
} from 'actions/Enquetes';

const obterContexto = () => {
  const idClienteRaw = localStorage.getItem('idClienteFixado');
  const idUsuarioRaw = localStorage.getItem('user_id');

  const idCliente = idClienteRaw ? parseInt(idClienteRaw, 10) : 0;
  const idUsuario = idUsuarioRaw ? parseInt(idUsuarioRaw, 10) : 0;

  return {
    IdCliente: Number.isNaN(idClienteRaw) ? 0 : idClienteRaw,
    IdUsuario: Number.isNaN(idUsuario) ? 0 : idUsuario,
  };
};

const normalizaErro = (retorno, fallback) => {
  const status = retorno?.response?.status;
  const data = retorno?.response?.data;

  if (status === 400 || status === 406) {
    const inconsistencias = data?.inconsistencias || [];
    if (Array.isArray(inconsistencias) && inconsistencias.length > 0) {
      return inconsistencias[0]?.mensagem || fallback;
    }

    return data?.mensagem || data?.message || fallback;
  }

  if (retorno?.message) {
    return retorno.message;
  }

  return fallback;
};

const carregaEnquetesRequest = async () => {
  const contexto = obterContexto();
  return await requisicaoApi.get('/v1/enquetes/listar', { params: contexto })
    .then((resposta) => resposta)
    .catch((error) => error);
};

const carregaEnquetePorIdRequest = async (idEnquete) => {
  return await requisicaoApi.get(`/v1/enquetes/${idEnquete}`)
    .then((resposta) => resposta)
    .catch((error) => error);
};

const registraVotoRequest = async (payload) => {
  return await requisicaoApi.post('/enquetes/votar', payload)
    .then((resposta) => resposta)
    .catch((error) => error);
};

const salvaEnqueteRequest = async (dto) => {
  const id = dto?.request?.id || null;

  if (id) {
    return await requisicaoApi.put(`/v1/enquetes/${id}`, dto.request)
      .then((resposta) => resposta)
      .catch((error) => error);
  }

  return await requisicaoApi.post('/v1/enquetes', dto)
    .then((resposta) => resposta)
    .catch((error) => error);
};

const removeEnqueteRequest = async (id) => {
  return await requisicaoApi.delete(`/v1/enquetes/${id}`)
    .then((resposta) => resposta)
    .catch((error) => error);
};

const normalizaTexto = (valor) => String(valor || '').trim();

const montaDtoEnquete = (enquete) => {
  console.log(enquete)
  return {
    clienteId: Number(localStorage.getItem('idClienteFixado')),
    request: {
      ...enquete
    }
  }
};

function* fnIniciaEnquetes() {
  try {
    const retorno = yield call(carregaEnquetesRequest);

    if (retorno?.message) {
      yield put(showEnquetesMessage(normalizaErro(retorno, 'Falha ao carregar enquetes.')));
      return;
    }

    if (retorno?.status === 204) {
      yield put(inicioEnquetesSucesso([]));
      return;
    }

    yield put(inicioEnquetesSucesso(retorno?.data || []));
  } catch (error) {
    yield put(showEnquetesMessage(normalizaErro(error, 'Falha ao carregar enquetes.')));
  }
}

function* fnListaEnquetes() {
  try {
    const retorno = yield call(carregaEnquetesRequest);

    if (retorno?.message) {
      yield put(showEnquetesMessage(normalizaErro(retorno, 'Falha ao carregar enquetes.')));
      return;
    }

    if (retorno?.status === 204) {
      yield put(listaEnquetesSucesso([]));
      return;
    }

    yield put(listaEnquetesSucesso(retorno?.data || []));
  } catch (error) {
    yield put(showEnquetesMessage(normalizaErro(error, 'Falha ao carregar enquetes.')));
  }
}

function* fnBuscaEnqueteEdicao({ payload }) {
  try {
    if (String(payload || '').startsWith('local-')) {
      const listaLocal = yield select((state) => (state.enquetes && state.enquetes.listGrid) || []);
      const enqueteLocal = Array.isArray(listaLocal)
        ? listaLocal.find((item) => String(item.id) === String(payload))
        : null;

      if (enqueteLocal) {
        yield put(buscaEnqueteEdicaoSucesso(enqueteLocal));
        return;
      }
    }

    const retorno = yield call(carregaEnquetePorIdRequest, payload);

    if (retorno?.message) {
      yield put(showEnquetesMessage(normalizaErro(retorno, 'Falha ao carregar a enquete.')));
      return;
    }

    yield put(buscaEnqueteEdicaoSucesso(retorno?.data || null));
  } catch (error) {
    yield put(showEnquetesMessage(normalizaErro(error, 'Falha ao carregar a enquete.')));
  }
}

function* fnAbreDashboardEnquete({ payload }) {
  try {
    const retorno = yield call(carregaEnquetePorIdRequest, payload);

    if (retorno?.message) {
      yield put(showEnquetesMessage(normalizaErro(retorno, 'Falha ao carregar os resultados.')));
      return;
    }

    yield put(abreDashboardEnqueteSucesso(retorno?.data || null));
  } catch (error) {
    yield put(showEnquetesMessage(normalizaErro(error, 'Falha ao carregar os resultados.')));
  }
}

function* fnRegistraVotoEnquete({ payload }) {
  try {
    const retorno = yield call(registraVotoRequest, payload);

    if (retorno?.message) {
      yield put(showEnquetesMessage(normalizaErro(retorno, 'Falha ao registrar o voto.')));
      return;
    }

    yield put(registraVotoEnqueteSucesso('Voto registrado com sucesso.'));
    yield put(listaEnquetes());

    if (payload?.IdEnquete || payload?.idEnquete) {
      yield put({ type: BUSCA_ENQUETE_EDICAO, payload: payload.IdEnquete || payload.idEnquete });
    }
  } catch (error) {
    yield put(showEnquetesMessage(normalizaErro(error, 'Falha ao registrar o voto.')));
  }
}

function* fnSalvaEnquete({ payload }) {
  try {
    const enquete = payload?.enquete || {};
    const continuarNovo = !!payload?.continuarNovo;
    const dto = montaDtoEnquete(enquete);
    const retorno = yield call(salvaEnqueteRequest, dto);

    if (retorno?.message) {
      yield put(showEnquetesMessage(normalizaErro(retorno, 'Falha ao salvar a enquete.')));
      return;
    }

    const dados = retorno?.data || {};
    const idSalvo = Number(dados?.id || dados?.Id || dto.Id || 0);
    const mensagem = dados?.mensagem || (dto.Id > 0 ? 'Enquete atualizada com sucesso.' : 'Enquete criada com sucesso.');

    yield put(salvaEnqueteSucesso({
      mensagem,
      continuarNovo,
      enquete: {
        ...enquete,
        id: idSalvo,
      },
    }));
    yield put(listaEnquetes());
  } catch (error) {
    yield put(showEnquetesMessage(normalizaErro(error, 'Falha ao salvar a enquete.')));
  }
}

function* fnRemoveEnquete({ payload }) {
  try {
    const id = payload;
    const retorno = yield call(removeEnqueteRequest, id);

    if (retorno?.message) {
      yield put(showEnquetesMessage(normalizaErro(retorno, 'Falha ao remover a enquete.')));
      return;
    }

    const dados = retorno?.data || {};
    const mensagem = dados?.mensagem || 'Enquete removida com sucesso.';

    yield put(removeEnqueteSucesso({ mensagem }));
    yield put(listaEnquetes());
  } catch (error) {
    yield put(showEnquetesMessage(normalizaErro(error, 'Falha ao remover a enquete.')));
  }
}

export function* iniciaEnquetes() {
  yield takeEvery(INICIA_ENQUETES, fnIniciaEnquetes);
}

export function* listaEnquetesSaga() {
  yield takeEvery(LISTA_ENQUETES, fnListaEnquetes);
}

export function* buscaEnqueteEdicao() {
  yield takeEvery(BUSCA_ENQUETE_EDICAO, fnBuscaEnqueteEdicao);
}

export function* abreDashboardEnquete() {
  yield takeEvery(ABRE_DASHBOARD_ENQUETE, fnAbreDashboardEnquete);
}

export function* registraVotoEnquete() {
  yield takeEvery(REGISTRA_VOTO_ENQUETE, fnRegistraVotoEnquete);
}

export function* salvaEnquete() {
  yield takeEvery(SALVA_ENQUETE_LOCAL, fnSalvaEnquete);
}

export function* removeEnquete() {
  yield takeEvery(REMOVE_ENQUETE_LOCAL, fnRemoveEnquete);
}

export default function* rootSaga() {
  yield all([
    fork(iniciaEnquetes),
    fork(listaEnquetesSaga),
    fork(buscaEnqueteEdicao),
    fork(abreDashboardEnquete),
    fork(registraVotoEnquete),
    fork(salvaEnquete),
    fork(removeEnquete),
  ]);
}
